import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import {
  EntityActionNames,
  IEntityAction,
} from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { ILabelValueAction } from '~src/spacesPlatform/models/actionNames';
import { currentUserIsAdmin } from '~src/spacesPlatform/utils/MixedContentHelpers';

import { Messages } from '../../../codegen/Localize';
import { setSensitiveOrWarningLabelValueAction } from '../../actions/labels/SetSensitiveOrWarningLabelValueAction';
import { ILabelValueInfo } from '../../models/ILabelValueInfo';
import { selectCatalogingOnSiteEnabled } from '../../selectors/CatalogSelectors';

export const SetSensitiveOrWarningLabelValueEntityAction: IEntityAction<
  ILabelValueInfo,
  ILabelValueAction
> = {
  name: EntityActionNames.SetSensitivityOrWarningLabelValue,
  translateName: Messages.edit,
  isVisible: (items, state) =>
    selectCatalogingOnSiteEnabled(state) &&
    FeatureFlags.labelManagementEnabled &&
    currentUserIsAdmin(state) &&
    isSensitivityOrWarningOrCustomCategory(items),
  isClickable: (_, targetItems) => targetItems.length === 1,
  createReduxAction: (items) => {
    if (!items || items.length === 0 || items.length > 1) {
      throw new Error(Messages.setSensitiveDataLabelError());
    }
    return setSensitiveOrWarningLabelValueAction(items[0]);
  },
};

function isSensitivityOrWarningOrCustomCategory(items: ILabelValueInfo[]) {
  if (
    items[0].value === 'EXTRACT_REFRESH_FAILURE' ||
    items[0].value === 'FLOW_RUN_FAILURE' ||
    items[0].category === 'CERTIFICATION'
  ) {
    return false;
  }
  return true;
}
